import { createFileRoute } from "@tanstack/react-router";
import { LegalPage, legalHead } from "@/pages/LegalPage";
import { persondataStrings } from "@/i18n/content/legal";

export const Route = createFileRoute("/de/datenschutzbestimmungen")({
  head: () => legalHead("persondata", "de", persondataStrings.de.meta),
  component: () => <LegalPage {...persondataStrings.de} />,
});
